import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CleanIcon from '../../assets/icons/clean-icon.svg';

const IconCleaning = (props) => {
    const { className, rootClassName } = props;
    const classes = classNames(rootClassName, className);

    return <img className={classes} src={CleanIcon} alt="cleaning icon" />;
};

const { string } = PropTypes;

IconCleaning.defaultProps = {
    className: null,
    rootClassName: null,
};

IconCleaning.propTypes = {
    className: string,
    rootClassName: string,
};

export default IconCleaning;
